import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProfessionnelRoutingModule } from './professionnel-routing.module';
import { SharedModule } from '../shared/shared.module';
import { DossierHistoriqueComponent } from './dossier-historique/dossier-historique.component';
import { EnCoursComponent } from './dossier-historique/en-cours/en-cours.component';
import { EnCorrectionComponent } from './dossier-historique/en-correction/en-correction.component';
import { ClotureComponent } from './dossier-historique/cloture/cloture.component';
import { AbandonneComponent } from './dossier-historique/abandonne/abandonne.component';
import { DossierInfoComponent } from './dossier-info/dossier-info.component';
import { DossierInfoDetailTabComponent } from './dossier-info/tab/dossier-info-detail-tab/dossier-info-detail-tab.component';
import { DossierUpdateComponent } from './dossier-update/dossier-update.component';
import { UpdateDossierInfoComponent } from './dossier-update/form/update-dossier-info/update-dossier-info.component';
import { FormulaireLayoutComponent } from './formulaire/formulaire-layout/formulaire-layout.component';
import { CreateDossierCreditComponent } from './formulaire/createform/create-dossier-credit/create-dossier-credit.component';
import { DossierHistoriqueNewComponent } from './dossier-historique-new/dossier-historique-new.component';
import { ReportingModule } from '../reporting/reporting.module';
import { FormulaireModule } from '../formulaire/formulaire.module';
import { ParametrageModule } from '../parametrage/parametrage.module';
import { FormMisEnPlaceComponent } from './formulaire/taskform/form-mis-en-place/form-mis-en-place.component';
import { FormScanPieceComponent } from './formulaire/taskform/form-scan-piece/form-scan-piece.component';
import { EditCreditModalComponent } from './formulaire/modal/edit-credit-modal/edit-credit-modal.component';
import { FormGenerationLettreNotificationComponent } from './formulaire/taskform/form-generation-lettre-notification/form-generation-lettre-notification.component';
import { FormGenerationFicheMiseEnPlaceComponent } from './formulaire/taskform/form-generation-fiche-mise-en-place/form-generation-fiche-mise-en-place.component';
import { FormVerificationConditionSuspensiveComponent } from './formulaire/taskform/form-verification-condition-suspensive/form-verification-condition-suspensive.component';
import { FormAddConditionComponent } from './formulaire/modal/form-add-condition/form-add-condition.component';
import { FormEditConditionComponent } from './formulaire/modal/form-edit-condition/form-edit-condition.component';
import { FormVerificationConditionSuspensiveTestComponent } from './formulaire/taskform/form-verification-condition-suspensive-test/form-verification-condition-suspensive-test.component';
import { AddGarantieToDossierComponent } from './formulaire/createform/add-garantie-to-dossier/add-garantie-to-dossier.component';
import { ItemDetailComponent } from './dossier-info/tab/garantie-list/item-detail/item-detail.component';
import { AddDocumentGarantieComponent } from './dossier-info/tab/garantie-list/add-document-garantie/add-document-garantie.component';
import { EditGarantieDetailComponent } from './dossier-info/tab/garantie-list/edit-garantie-detail/edit-garantie-detail.component';
import { AddGarantieDetailComponent } from './dossier-info/tab/garantie-list/add-garantie-detail/add-garantie-detail.component';
import { GarantieListComponent } from './dossier-info/tab/garantie-list/garantie-list.component';
import { TirageTabComponent } from './dossier-info/tab/tirage-tab/tirage-tab.component';
import { AddTirageComponent } from './dossier-info/tab/tirage-tab/add-tirage/add-tirage.component';
import { EditTirageComponent } from './dossier-info/tab/tirage-tab/edit-tirage/edit-tirage.component';
import { ConfirmCreditModalComponent } from './formulaire/modal/confirm-credit-modal/confirm-credit-modal.component';
import { FormMiseEnPlaceTirageComponent } from './formulaire/taskform/form-mise-en-place-tirage/form-mise-en-place-tirage.component';
import { TousComponent } from './dossier-historique/tous/tous.component';
import { DossierHistoriqueAllComponent } from './dossier-historique-all/dossier-historique-all.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';

@NgModule({
  imports: [
    NgMultiSelectDropDownModule.forRoot(),
    CommonModule,
    SharedModule,
    ProfessionnelRoutingModule,
    ParametrageModule,
    FormulaireModule,
    ReportingModule,
    NgxDaterangepickerMd.forRoot()
  ],

  declarations: [
    DossierHistoriqueComponent,
    EnCoursComponent,
    EnCorrectionComponent,
    ClotureComponent,
    AbandonneComponent,
    DossierInfoComponent,
    DossierInfoDetailTabComponent,
    DossierUpdateComponent,
    UpdateDossierInfoComponent,
    FormulaireLayoutComponent,
    CreateDossierCreditComponent,
    DossierHistoriqueNewComponent,
    FormMisEnPlaceComponent,
    FormScanPieceComponent,
    EditCreditModalComponent,
    FormGenerationLettreNotificationComponent,
    FormGenerationFicheMiseEnPlaceComponent,
    FormVerificationConditionSuspensiveComponent,
    FormAddConditionComponent,
    FormEditConditionComponent,
    FormVerificationConditionSuspensiveTestComponent,
    AddGarantieToDossierComponent,

    ItemDetailComponent,
    GarantieListComponent,
    AddDocumentGarantieComponent,
    EditGarantieDetailComponent,
    AddGarantieDetailComponent,
    TirageTabComponent,
    AddTirageComponent,
    EditTirageComponent,
    ConfirmCreditModalComponent,
    FormMiseEnPlaceTirageComponent,
    TousComponent,
    DossierHistoriqueAllComponent,
  ],

  entryComponents: [
    EditCreditModalComponent,
    FormAddConditionComponent,
    FormEditConditionComponent,
    ItemDetailComponent,
    AddDocumentGarantieComponent,
    EditGarantieDetailComponent,
    AddGarantieDetailComponent,
    AddTirageComponent,
    EditTirageComponent,
    ConfirmCreditModalComponent
  ],

  providers: [
  ],

})
export class ProfessionnelModule { }
